import React from 'react';
import SectionMessage from '@atlaskit/section-message';
import { FormattedMessage } from 'react-intl';
import { isEnterpriseOrgProduct } from '../../../../../util/mac/helpers';
import { ATLASSIAN_TOGETHER } from '../../../../../data/products/keys';
import styled from 'styled-components';
import { Dimensions } from '../../../../../components/visuals';

const List = styled.ul`
  padding-left: ${Dimensions.units(2)}px;
  margin-top: ${Dimensions.units(0.5)}px;
`;

const SectionHeader = styled.div`
  font-weight: bold;
`;

const BannerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Dimensions.units(1.5)}px;
`;

export const HostedAtlassianOrganizationAccount = ({ accountDetails }) => {
  const enterpriseOrgProducts = accountDetails?.children?.filter(
    (acc) => acc.active && isEnterpriseOrgProduct(acc?.merchandise?.productPackage?.key),
  );

  const atlassianTogetherOrgProducts = accountDetails?.children?.filter(
    (acc) => acc?.merchandise?.productPackage?.key === ATLASSIAN_TOGETHER,
  );

  return (
    <>
      <BannerContent>
        {enterpriseOrgProducts?.length > 0 && (
          <SectionMessage>
            <SectionHeader>
              <FormattedMessage
                id="mac.licenses.actions.enterprise.subscription"
                defaultMessage="Your Enterprise subscriptions"
              />
            </SectionHeader>
            <List>
              {enterpriseOrgProducts?.map((product) => (
                <li key={product.id}>{product?.merchandise?.productPackage?.description}</li>
              ))}
            </List>
          </SectionMessage>
        )}

        {atlassianTogetherOrgProducts?.length > 0 && (
          <SectionMessage>
            <SectionHeader>
              <FormattedMessage
                id="mac.licenses.actions.atlassian.together.subscription"
                defaultMessage="Your Atlassian Together subscriptions"
              />
            </SectionHeader>
            <List>
              {atlassianTogetherOrgProducts?.map((product) => (
                <li key={product.id}>{product?.merchandise?.productPackage?.description}</li>
              ))}
            </List>
          </SectionMessage>
        )}
      </BannerContent>
    </>
  );
};
